import React from "react";
import MuiRadioGroup, {
  RadioGroupProps as MuiRadioGroupProps,
} from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import { getIn, useField, useFormikContext } from "formik";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    display: "inline-flex",
    flexDirection: "row",
  },
});

interface IProps extends MuiRadioGroupProps {
  inline?: boolean;
  label?: string;
  name: string;
}

export const FormikRadioGroup: React.FunctionComponent<IProps> = ({
  name,
  inline,
  label,
  onChange,
  ...props
}: IProps) => {
  const { isSubmitting, errors, touched, setFieldValue } = useFormikContext();

  const fieldError = getIn(errors, name);
  const showError = getIn(touched, name) && !!fieldError;

  const customClasses = useStyles();
  const [field] = useField(name);

  const formikProps = { disabled: isSubmitting, value: field.value };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    onChange && onChange(event, value);

    if (event.target.value === "true" || event.target.value === "false") {
      setFieldValue(name, event.target.value === "true");
      return;
    }

    const numValue = parseInt(event.target.value);
    setFieldValue(name, Number.isNaN(numValue) ? event.target.value : numValue);
  };
  return (
    <FormControl error={showError}>
      {label && <FormLabel>{label}</FormLabel>}
      <MuiRadioGroup
        onChange={handleChange}
        {...formikProps}
        {...props}
        classes={inline ? customClasses : {}}
      >
        {props.children}
      </MuiRadioGroup>
      {showError && <FormHelperText error>{fieldError}</FormHelperText>}
    </FormControl>
  );
};
